import { StaticBlobsPosition } from '@/components/AnimatedBackground/types';

export const PURPLE_BLOB_COLORS = ['#29007B', '#3B00B4', '#671DFF', '#3F00BF'] as const;
export const GREEN_MOVING_BLOB_COLORS = ['#B0FF34', '#bef868', '#c9fa81'] as const;
export const GREEN_STATIC_BLOB_COLORS = ['#B0FF34', '#91EF00', '#B0FF34', '#bef868'] as const;

export const STATIC_BLOB_POSITIONS: Record<
	StaticBlobsPosition,
	[{ left: string; top: string }, { left: string; top: string }]
> = {
	'top-right_bottom-left': [
		{ left: '5%', top: '75%' },
		{ left: '100%', top: '30%' }
	],
	'top-left_bottom-right': [
		{ left: '-10%', top: '10%' },
		{ left: '90%', top: '75%' }
	],
	'sides-center': [
		{ left: '10%', top: '60%' },
		{ left: '95%', top: '50%' }
	]
};

export const GREEN_STATIC_QUAD_POSITIONS: Record<
	StaticBlobsPosition,
	[
		{ left: string; top: string },
		{ left: string; top: string },
		{ left: string; top: string },
		{ left: string; top: string }
	]
> = {
	'top-right_bottom-left': [
		{ left: '5%', top: '75%' },
		{ left: '100%', top: '30%' },
		{ left: '28%', top: '66%' },
		{ left: '82%', top: '47%' }
	],
	'top-left_bottom-right': [
		{ left: '-8%', top: '12%' },
		{ left: '92%', top: '72%' },
		{ left: '42%', top: '6%' },
		{ left: '8%', top: '92%' }
	],
	'sides-center': [
		{ left: '8%', top: '58%' },
		{ left: '96%', top: '48%' },
		{ left: '50%', top: '18%' },
		{ left: '48%', top: '88%' }
	]
};

export const GREEN_STATIC_BLOB_SIZES = [
	'max(52vw, 600px)',
	'max(52vw, 600px)',
	'max(59vw, 650px)',
	'max(59vw, 650px)'
] as const;

export const GREEN_MOVING_BLOB_SIZES = [
	'max(40vw, 380px)',
	'max(44vw, 420px)',
	'max(36vw, 340px)'
] as const;
